import { ROUTE_PAGE_API } from '../config/apiPoints';
import { IOperatorsData, IBusData } from './redux/validations'
import { getIconName } from '../config/config'
import { fetchHelper } from '../../utils/fetchHelper';
import dateformat from 'dateformat';


export const prepareRoutePageRequest = (params) => {
  const url = `${__ENV_CONFIG__.__PAGEROVER__}${ROUTE_PAGE_API}?src=${params.src}&dest=${params.dest}`
  return url;
}

export const getRoutePageData = async (params) => {
  const url = prepareRoutePageRequest(params);
  let data = {}
  try {
    data = await fetchHelper({
      name: 'route page',
      type: 'GET',
      url: url,
    });
  } catch (err) {
    data = {
      status: false,
      error: true
    }
  }
  return data;
}

//TODO add the return type validation
export function getCategoryData(operators: IOperatorsData[], buses: IBusData[], journeyType: string, popular_filters: any, bp_dict: any, dp_dict: any, src_id: any, dest_id: any, route_logic?: string[], other_buses?: IBusData[], other_operators?: IOperatorsData[]) {
  let rtcBuses = {};
  let otherRTCBuses = {}
  let privateAvailableBuses = { onw: [], ret: [] };
  let privateSoldOutBuses = { onw: [], ret: [] };
  let otherPrivateAvailableBuses = { onw: [], ret: [] };
  const bpList = { onw: [], ret: [] };
  const dpList = { onw: [], ret: [] };
  let operatorsList = { onw: [], ret: [] };
  let amenities = {};
  let primaryFiltersInfo = getDefaultPrimaryFilterInfo()
  let isOTGApplicable = false;
  let isGosafe = false;
  let isLiveTracking = false;
  let isRedDeal = false;

  if (operators) {
    operators.forEach(item => {
      if (!rtcBuses[item.opid]) {
        const obj = {
          availableBuses: [],
          earliest_departure: function () {
            if (item.starts_from) {
              let str = ''
              try {
                str = dateformat(new Date(item.starts_from), 'HH:MM')//2021-09-10T00:15:00
              } catch (err) {

              }
              return str;
            }

          }(),
          fastest_duration: '',
          slowest_duration: '',
          busCount: item.total_count || 0,
          seatCount: item.seats_avl || 0,
          cheapest_price: item.min_fare || 0,
          soldOutBuses: [],
        };

        rtcBuses[item.opid] = {
          img_url: item.image_url,
          opid: item.opid,
          name: item.name,
          onw: obj,
          ret: obj,
          f_name: item.f_name,
          op_url: item.op_url,
          msg: item?.msg
        };
      }
    });
  }
  if (other_operators) {
    other_operators.forEach(item => {
      if (!otherRTCBuses[item.opid]) {
        const obj = {
          availableBuses: [],
          earliest_departure: '',
          fastest_duration: '',
          slowest_duration: '',
          busCount: item.total_count,
          seatCount: item.seats_avl,
          cheapest_price: item.min_fare,
          soldOutBuses: [],
        };

        otherRTCBuses[item.opid] = {
          img_url: item.image_url,
          opid: item.opid,
          name: item.name,
          onw: obj,
          ret: obj,
          f_name: item.f_name
        };
      }
    });
  }

  const popularFilters = function () {
    let filters = [];
    for (const i in popular_filters) {
      if (popular_filters.hasOwnProperty(i)) {
        filters.push({ index: i, k: popular_filters[i].k, v: popular_filters[i].v, icon: getIconName(popular_filters[i].k) })

      }
    }
    return filters;
  }()
  buses.forEach(bus => {
    if (bus.fl[0].ot) {
      isOTGApplicable = true;
    }
    if (bus.go_safe) {
      isGosafe = true;
    }
    if (bus.reddeal && Object.keys(bus.reddeal).length) {
      isRedDeal = true;
    }
    if (bus.fl[0].gps) {
      isLiveTracking = true
    }

    let busOperator = null;
    let busBPList = null;
    let busDPList = null;
    bus.card_BPDP_Info = {
      bp: Array.isArray(bus.fl[0].bp) ? bus.fl[0].bp : [bus.fl[0].bp],
      dp: Array.isArray(bus.fl[0].dp) ? bus.fl[0].dp : [bus.fl[0].dp]
    }
    const chooseBpDpFirst = bus.chooseBpDpFirst;
    const busSeatCount = bus.fl[0].rd && bus.fl[0].rd.length ? bus.fl[0].rd[0].SeatsAvailable : 0;
    const price = bus.fd.tf;

    const duration = bus.fl[0].du;
    const operatorId = bus.fl[0].op;
    const departureTime = bus.fl[0].dt;
    amenities = getAmenties(bus.amenities, amenities);
    primaryFiltersInfo = addPrimaryFiltersInfo(bus, primaryFiltersInfo)
    if (Object.keys(rtcBuses).length && operatorId && rtcBuses[operatorId]) {

    } else {
      busBPList = chooseBpDpFirst ? (Array.isArray(bus.fl[0].bp) ? bus.fl[0].bp : [bus.fl[0].bp]) : getBPList(bp_dict, operatorId);
      busDPList = chooseBpDpFirst ? (Array.isArray(bus.fl[0].dp) ? bus.fl[0].dp : [bus.fl[0].dp]) : getDPList(dp_dict, operatorId);
      bus.fl[0].bp = busBPList;
      bus.fl[0].dp = busDPList;
      bus.filterHash = '';

      privateAvailableBuses[journeyType].push(Object.assign({}, bus));

    }
    busOperator = { id: bus.op, name: formatBusOperatorName(rtcBuses, bus) };

    if (busOperator && !operatorsList[journeyType].find(opItem => opItem.id === busOperator.id) && busOperator.name) {
      operatorsList[journeyType].push(busOperator);
    }

    if (busBPList && busBPList.length > 0) {
      busBPList.forEach(bpItem => {
        const formattedBpItem = formatString(bpItem.BPN);
        if (!(bpList[journeyType].indexOf(formattedBpItem) > -1)) {
          bpList[journeyType].push(formattedBpItem);
        }
      });
    }

    if (busDPList && busDPList.length > 0) {
      busDPList.forEach(dpItem => {
        const formattedDpItem = formatString(dpItem.DPN);
        if (!(dpList[journeyType].indexOf(formattedDpItem) > -1)) {
          dpList[journeyType].push(formattedDpItem);
        }
      });
    }
  });
  if (other_buses && other_buses) {
    other_buses.forEach(bus => {
      if (bus.fl[0].ot) {
        isOTGApplicable = true;
      }
      if (bus.go_safe) {
        isGosafe = true;
      }
      if (bus.reddeal && Object.keys(bus.reddeal).length) {
        isRedDeal = true;
      }
      if (bus.fl[0].gps) {
        isLiveTracking = true
      }

      let busOperator = null;
      let busBPList = null;
      let busDPList = null;
      bus.card_BPDP_Info = {
        bp: Array.isArray(bus.fl[0].bp) ? bus.fl[0].bp : [bus.fl[0].bp],
        dp: Array.isArray(bus.fl[0].dp) ? bus.fl[0].dp : [bus.fl[0].dp]
      }
      const chooseBpDpFirst = bus.chooseBpDpFirst;

      const operatorId = bus.fl[0].op;
      amenities = getAmenties(bus.amenities, amenities);
      primaryFiltersInfo = addPrimaryFiltersInfo(bus, primaryFiltersInfo)

      busBPList = chooseBpDpFirst ? (Array.isArray(bus.fl[0].bp) ? bus.fl[0].bp : [bus.fl[0].bp]) : getBPList(bp_dict, operatorId);
      busDPList = chooseBpDpFirst ? (Array.isArray(bus.fl[0].dp) ? bus.fl[0].dp : [bus.fl[0].dp]) : getDPList(dp_dict, operatorId);
      bus.fl[0].bp = busBPList;
      bus.fl[0].dp = busDPList;
      bus.filterHash = ''
      otherPrivateAvailableBuses[journeyType].push(Object.assign({}, bus));

      busOperator = { id: bus.op, name: formatBusOperatorName(rtcBuses, bus) };
      if (busOperator && !operatorsList[journeyType].find(opItem => opItem.id === busOperator.id) && busOperator.name) {
        operatorsList[journeyType].push(busOperator);
      }
      if (busBPList && busBPList.length > 0) {
        busBPList.forEach(bpItem => {
          const formattedBpItem = formatString(bpItem.BPN);
          if (!(bpList[journeyType].indexOf(formattedBpItem) > -1)) {
            bpList[journeyType].push(formattedBpItem);
          }
        });
      }
      if (busDPList && busDPList.length > 0) {
        busDPList.forEach(dpItem => {
          const formattedDpItem = formatString(dpItem.DPN);
          if (!(dpList[journeyType].indexOf(formattedDpItem) > -1)) {
            dpList[journeyType].push(formattedDpItem);
          }
        });
      }
    });
  }
  amenities = getViewAmenties(amenities);
  const sortedAmenities = [amenities].sort(
    busSortComparator({ sortType: 'string', sortKey: 'title' }),
  );
  amenities = sortedAmenities[0];
  for (let key in operatorsList) {
    if (operatorsList.hasOwnProperty(key)) {
      operatorsList[key].sort(busSortComparator({ sortType: 'string', sortKey: 'name' }));
    }
  }
  for (let key in bpList) {
    if (bpList.hasOwnProperty(key)) {
      bpList[key].sort(sortByLowerCase);
    }
  }
  for (let key in dpList) {
    if (dpList.hasOwnProperty(key)) {
      dpList[key].sort(sortByLowerCase);
    }
  }
  return {
    rtcBuses,
    privateAvailableBuses,
    privateSoldOutBuses,
    dpList,
    bpList,
    operatorsList,
    amenities,
    popularFilters,
    primaryFiltersInfo,
    isOTGApplicable,
    isGosafe,
    isLiveTracking,
    isRedDeal,
    otherPrivateAvailableBuses,
    otherRTCBuses,
    isRouteEnable: function () {
      let enable = false;
      // ["all-all"]
      // ["all-id"]
      // ["id-all"]
      // ["id-id"]

      if (route_logic && route_logic.length) {
        for (let i in route_logic) {
          const routeInfo = route_logic[i].split("-");
          const enabledSrc = routeInfo[0];
          const enabledDest = routeInfo[1];
          if (enabledSrc == "all" && enabledDest == "all") {
            enable = true;
            break;
          }
          if (enabledSrc == "all" && enabledDest == dest_id) {
            enable = true;
            break;
          }
          if (enabledDest === "all" && enabledSrc == src_id) {
            enable = true;
            break;
          }
          if (enabledSrc == src_id && enabledDest == dest_id) {
            enable = true;
            break;
          }
        }
      }
      return enable;
    }()
  };
}

function getAmenties(busAmenities: string[], amenities: {}) {
  if (busAmenities && busAmenities.length && busAmenities[0] !== 'NA') {
    for (const i in busAmenities) {
      if (busAmenities[i] && !amenities[busAmenities[i]]) {
        amenities[busAmenities[i]] = { title: busAmenities[i], icon: busAmenities[i] };
      }
    }
  }
  return amenities;
}

export function formatBusOperatorName(rtcList, item) {
  if (Object.keys(rtcList).indexOf(item.op) > -1) {
    return item.bid.split('/')[3];
  }
  return formatString(item.fl[0].cr);
}

function getViewAmenties(amenities: any) {
  for (const key in amenities) {
    if (amenities.hasOwnProperty(key)) {
      const iconName = getIconName(amenities[key].icon) || '';

      amenities[key] = { title: (amenities[key].title), icon: iconName };
    }
  }

  return amenities;
}

function sortByLowerCase(a: any, b: any) {
  return a.toLowerCase().localeCompare(b.toLowerCase());
}

export function formatString(str: String) {
  return str.replace(/[(//:,^+*=)]/g, '');
}

function busSortComparator({ sortType = '', sortKey = '' }) {
  return (itemA, itemB) => {
    let itemA_data = itemA;
    let itemB_data = itemB;
    let tempFlag;
    let res;
    if (sortType.indexOf('price') !== -1) {
      itemA_data = parseInt(itemA_data.fd.pp, 10);
      itemB_data = parseInt(itemB_data.fd.pp, 10);
      if (sortType === 'low_price') {
        tempFlag = itemA_data > itemB_data ? -1 : 1;
      } else {
        tempFlag = itemA_data < itemB_data ? -1 : 1;
      }
    }
    if (sortType.indexOf('departure') !== -1) {
      itemA_data = itemA_data.fl[0].dt;
      itemB_data = itemB_data.fl[0].dt;
      if (sortType === 'early_departure') {
        tempFlag = itemA_data > itemB_data ? -1 : 1;
      } else {
        tempFlag = itemA_data < itemB_data ? -1 : 1;
      }
    }
    if (sortType.indexOf('arrival') !== -1) {
      itemA_data = itemA_data.fl[0].at;
      itemB_data = itemB_data.fl[0].at;
      if (sortType === 'early_arrival') {
        tempFlag = itemA_data > itemB_data ? -1 : 1;
      } else {
        tempFlag = itemA_data < itemB_data ? -1 : 1;
      }
    }

    if (sortType.indexOf('speed') !== -1) {
      const duArrA_data = itemA_data.fl[0].du.split(' ');
      if (duArrA_data && duArrA_data.length && duArrA_data.length > 1) {
        const minA = parseInt(duArrA_data[1].replace(/m/g, ''), 10);
        itemA_data = parseFloat(`${duArrA_data[0].replace(/h/g, '')}${minA / 60}`);
      }
      const duArrB_data = itemB_data.fl[0].du.split(' ');
      if (duArrB_data && duArrB_data.length && duArrB_data.length > 1) {
        const minB = parseInt(duArrB_data[1].replace(/m/g, ''), 10);
        itemB_data = parseFloat(`${duArrB_data[0].replace(/h/g, '')}${minB / 60}`);
      }
      if (sortType === 'high_speed') {
        tempFlag = itemA_data < itemB_data ? -1 : 1;
      } else {
        tempFlag = itemA_data > itemB_data ? -1 : 1;
      }
    }
    if (sortType.indexOf('rating') !== -1) {
      itemA_data = parseFloat(itemA_data.fl[0].rating);
      itemB_data = parseFloat(itemB_data.fl[0].rating);
      if (sortType === 'rating_low') {
        tempFlag = itemA_data > itemB_data ? 1 : -1;
      } else {
        tempFlag = itemA_data < itemB_data ? 1 : -1;
      }
    }
    if (sortType === 'best') {
      itemA_data = parseFloat(itemA_data.bs);
      itemB_data = parseFloat(itemB_data.bs);
      tempFlag = itemA_data < itemB_data ? 1 : -1;
    }
    if (sortKey && sortType === 'string') {
      tempFlag = itemA_data[sortKey].toLowerCase() > itemB_data[sortKey].toLowerCase() ? 1 : -1;
    }

    res = itemA_data === itemB_data ? 0 : tempFlag;
    return res;
  };
}

function getBPList(bp_dict, operatorId) {
  if (!bp_dict) {
    return []
  }
  let list = [];
  for (let bpName in bp_dict) {
    if (bp_dict.hasOwnProperty(bpName) && bp_dict[bpName].indexOf(operatorId) !== -1) {
      list.push({
        BPN: bpName
      })

    }
  }
  return list;
}

function getDPList(dp_dict, operatorId) {
  if (!dp_dict) {
    return []
  }
  let list = [];
  for (let dpName in dp_dict) {
    if (dp_dict.hasOwnProperty(dpName) && dp_dict[dpName].indexOf(operatorId) !== -1) {
      list.push({
        DPN: dpName
      })

    }
  }
  return list;
}

export function getDefaultPrimaryFilterInfo() {
  return {
    '12-11': 0,
    '11-5': 0,
    '5-9': 0,
    '9-12': 0,
    'ac': 0,
    'nonac': 0,
    'seater': 0,
    'sleeper': 0
  };
}

export function addPrimaryFiltersInfo(item, primaryFiltersInfo) {
  /*    '12-11': 0, 0-11
      '11-5': 0, 11-17
      '5-9': 0, 17-21
      '9-12': 0, 21-24
      'ac': 0,
      'nonac': 0,
      'seater': 0,
      'sleeper': 0
  */
  const { fl } = item;
  const { dt, rd } = fl[0];
  const arr = dt.split(':');
  const hh = parseInt(arr[0], 0);
  const min = parseInt(arr[1], 10);
  let depT = parseInt(dt.split(':')[0], 10);
  depT = (depT === 0 ? 24 : depT);

  if (depT >= 0 && depT < 11) {
    primaryFiltersInfo['12-11'] = primaryFiltersInfo['12-11'] + 1;

  } else if (depT >= 11 && depT < 17) {
    primaryFiltersInfo['11-5'] = primaryFiltersInfo['11-5'] + 1;
  } else if (depT >= 17 && depT < 21) {
    primaryFiltersInfo['5-9'] = primaryFiltersInfo['5-9'] + 1;

  } else {
    primaryFiltersInfo['9-12'] = primaryFiltersInfo['9-12'] + 1;
  }
  let ac = 0;
  let nonac = 0;
  let sleeper = 0;
  let seater = 0;
  for (const i in rd) {
    const bc = rd[i].busCondition.toLowerCase();
    const st = rd[i].seatType.toLowerCase();
    const stArr = st.split('/');
    if (bc === 'ac') {
      ac = 1;
    } else if (bc === 'nonac') {
      nonac = 1;
    }
    for (let j in stArr) {
      if (stArr[j].indexOf('seater') !== -1 || stArr[j].indexOf('semi') !== -1) {
        seater = 1;
      }
      if (stArr[j].indexOf('sleeper') !== -1 && stArr[j].indexOf('semi') === -1) {
        sleeper = 1;
      }
    }

  }
  if (ac) {
    primaryFiltersInfo['ac'] = primaryFiltersInfo['ac'] + 1;

  } else if (nonac) {
    primaryFiltersInfo['nonac'] = primaryFiltersInfo['nonac'] + 1;
  }

  if (seater) {
    primaryFiltersInfo['seater'] = primaryFiltersInfo['seater'] + 1;
  }
  if (sleeper) {
    primaryFiltersInfo['sleeper'] = primaryFiltersInfo['sleeper'] + 1;
  }
  return primaryFiltersInfo;
}

export function getDay(initialOnwDateMonth) {
  const todayDateObj = new Date();
  const todayDate = todayDateObj.getDate();
  const currentMonth = todayDateObj.getMonth();
  const currentYear = todayDateObj.getFullYear();
  const todayDateStr = `${todayDate}${currentMonth}${currentYear}`;
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tommDate = new Date(tomorrow);
  const tommDateStr = `${tommDate.getDate()}${tommDate.getMonth()}${tommDate.getFullYear()}`;
  const selectedDate = initialOnwDateMonth.getDate();
  const selectedMonth = initialOnwDateMonth.getMonth();
  const selectedYear = initialOnwDateMonth.getFullYear();
  const selectedDateStr = `${selectedDate}${selectedMonth}${selectedYear}`;
  if (todayDateStr === selectedDateStr) {
    return 'Today,';
  } else if (tommDateStr === selectedDateStr) {
    return ' Tomorrow,';
  }
  return '';
}
